const getTotalPrice = function (item) {
    const price = item.priceTotal;
    return price.decimalValue;
};

const getUnitItemPrice = function (item) {
    const price = item.price;
    const list = price.list;
    const sales = price.sales;
    let itemPrice = 0;
    if (sales) {
        itemPrice = sales.value;
    } else if (list) {
        itemPrice = list.value;
    }

    return itemPrice;
};

const getUnitPriceOriginal = function (item) {
    const price = item.price;
    const list = price.list;
    const sales = price.sales;
    let itemPrice = 0;
    if (list) {
        itemPrice = list.value;
    } else if (sales) {
        itemPrice = sales.value;
    }

    return itemPrice;
};

module.exports = {
    handle: (e, data) => {
        if (data.error) {
            return;
        }

        if (typeof connectif === 'undefined' || !connectif) {
            return;
        }

        let cartObject = data.cart || data.basket;

        if (data.UUID || data.items) {
            cartObject = data
        }

        if (cartObject) {
            const products = [];

            cartObject.items.forEach(function (item) {
                let itemsPrice = getTotalPrice(item);
                let unitItemPrice = getUnitItemPrice(item);
                let images = item.images;
                let smallImage = images.small && images.small[0] ? images.small[0].absURL : null;
                let categories = item.category ? item.category.split('/') : [];
                let unitPriceOriginal = getUnitPriceOriginal(item);

                products.push({
                    quantity: item.quantity,
                    price: itemsPrice,
                    productDetailUrl: item.url,
                    productId: item.id,
                    name: item.productName,
                    imageUrl: smallImage,
                    unitPrice: unitItemPrice,
                    categories: categories,
                    brand: item.brand,
                    unitPriceOriginal: unitPriceOriginal,
                    discountedAmount: unitPriceOriginal - unitItemPrice
                });
            });

            connectif.managed.sendEvents([], {
                cart: {
                    cartId: cartObject.UUID,
                    totalQuantity: cartObject.numItems,
                    totalPrice: cartObject.totals.decimalGrandTotal,
                    products:products
                }
            });
        }
    }
}
